import { NgModule } from '@angular/core';
import { MatChipsModule } from '@angular/material/chips';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { ChipsComponent } from './chips.component';

@NgModule({
  declarations: [ChipsComponent],
  imports: [CommonModule, FormsModule, MatChipsModule],
  exports: [ChipsComponent],
})
export class ChipsModule {}
